import React, { useState, useEffect } from 'react';
import { Modal, List, Breadcrumb, Button, Space, message, Spin } from 'antd';
import { FolderOutlined, FileOutlined, HomeOutlined } from '@ant-design/icons';
import { FilesService } from '../api/services/files.service';

export default function FilePickerModal({ open, onCancel, onSelect }) {
  const [folders, setFolders] = useState([]);
  const [files, setFiles] = useState([]);
  const [currentFolder, setCurrentFolder] = useState(null);
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  useEffect(() => {
    if (open) {
      loadRoot();
    }
  }, [open]);

  const loadRoot = async () => {
    setLoading(true);
    try {
      const res = await FilesService.getRoot();
      setFolders(res.data);
      setFiles([]);
      setBreadcrumbs([]);
      setCurrentFolder(null);
      setSelectedFile(null);
    } catch (e) {
      message.error('Ошибка загрузки папок');
    } finally {
      setLoading(false);
    }
  };

  const loadFolder = async (folderId) => {
    setLoading(true);
    try {
      const res = await FilesService.getFolderById(folderId);
      setFolders(res.data.subfolders || []);
      setFiles(res.data.files || []);
      setBreadcrumbs(res.data.breadcrumbs || []);
      setCurrentFolder(res.data.folder);
      setSelectedFile(null);
    } catch (e) {
      message.error('Ошибка загрузки папки');
    } finally {
      setLoading(false);
    }
  };

  const handleOk = () => {
    if (!selectedFile) {
      message.warning('Выберите файл');
      return;
    }
    onSelect(selectedFile);
  };

  const getApprovalBorderColor = (status) => {
    if (status === 'active') return '2px solid #faad14'; // yellow/orange
    if (status === 'cancelled') return '2px solid #f5222d'; // red
    if (status === 'completed') return '2px solid #52c41a'; // green
    return 'none';
  };

  const getApprovalBackgroundColor = (status) => {
    if (status === 'active') return 'rgba(250, 173, 20, 0.05)';
    if (status === 'cancelled') return 'rgba(245, 34, 45, 0.05)';
    if (status === 'completed') return 'rgba(82, 196, 26, 0.05)';
    return 'transparent';
  };

  return (
    <Modal
      title="Выберите файл"
      open={open}
      onCancel={onCancel}
      onOk={handleOk}
      okText="Выбрать"
      cancelText="Отмена"
      width={700}
    >
      <Spin spinning={loading}>
        <div style={{ marginBottom: 16 }}>
          <Breadcrumb>
            <Breadcrumb.Item>
              <a onClick={loadRoot}>
                <HomeOutlined /> Корень
              </a>
            </Breadcrumb.Item>
            {breadcrumbs.map((crumb) => (
              <Breadcrumb.Item key={crumb.id}>
                <a onClick={() => loadFolder(crumb.id)}>{crumb.name}</a>
              </Breadcrumb.Item>
            ))}
            {currentFolder && (
              <Breadcrumb.Item>{currentFolder.name}</Breadcrumb.Item>
            )}
          </Breadcrumb>
        </div>

        <div style={{ height: 400, overflowY: 'auto', border: '1px solid #f0f0f0', padding: 8, borderRadius: 4 }}>
          {folders.length === 0 && files.length === 0 && (
            <div style={{ textAlign: 'center', padding: 20, color: '#999' }}>
              Папка пуста
            </div>
          )}
          
          <List
            dataSource={[...folders.map(f => ({ ...f, isFolder: true })), ...files.map(f => ({ ...f, isFolder: false }))]}
            renderItem={(item) => (
              <List.Item
                style={{
                  cursor: 'pointer',
                  backgroundColor: selectedFile?.id === item.id ? '#e6f7ff' : 'transparent',
                  padding: '8px 12px'
                }}
                onClick={() => {
                  if (item.isFolder) {
                    loadFolder(item.id);
                  } else {
                    setSelectedFile(item);
                  }
                }}
              >
                <Space>
                  {item.isFolder ? <FolderOutlined style={{ color: '#1890ff', fontSize: 18 }} /> : <FileOutlined style={{ fontSize: 18 }} />}
                  <span style={{ 
                    border: !item.isFolder && item.approval_status ? getApprovalBorderColor(item.approval_status) : 'none',
                    backgroundColor: !item.isFolder && item.approval_status ? getApprovalBackgroundColor(item.approval_status) : 'transparent',
                    padding: !item.isFolder && item.approval_status ? '2px 4px' : '0',
                    borderRadius: !item.isFolder && item.approval_status ? '4px' : '0'
                  }}>
                    {item.isFolder ? item.name : item.original_name}
                  </span>
                </Space>
              </List.Item>
            )}
          />
        </div>
      </Spin>
    </Modal>
  );
}
